import { v4 as uuid } from 'uuid';

export type DevLog = {
  id: string;
  message: unknown;
  createdAt: Date;
};

const MAX_SAVE_DEV_LOGS = 150;

export const SAVED_DEV_LOGS: DevLog[] = [];

export const logInDev = (message: unknown) => {
  // if (['develop', 'nextrc', 'dev', 'local'].includes(EnvConfiguration.environment)) {

  if (process.env['__DEV__']) {
    // eslint-disable-next-line no-console
    console.log(message);
  }

  if (SAVED_DEV_LOGS.length >= MAX_SAVE_DEV_LOGS) {
    SAVED_DEV_LOGS.shift();
  }

  SAVED_DEV_LOGS.push({
    id: uuid(),
    message,
    createdAt: new Date(),
  });
};
